<template>
  <div class="pcContainer" :style="{ height: `${containerHeight}px` }">
    <div class="pc">
      <div class="pc__inner">
        <div class="bg" :style="{ backgroundImage: `url(${bg})` }"></div>
        <div class="bgLeft" :style="{ left: `${marginLeft}px`}"></div>
        <div class="bgRight" :style="{ right: `${marginRight}px`}"></div>
        <div class="pc__grad">
          <div class="bg-grad"></div>
          <div class="texts">
            <div class="texts__inner">
              <img class="text" src="@/assets/pc/pc-text.png" alt="" />
              <img class="qr" src="@/assets/pc/pia-site-qr.png" alt="" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="pc__footer">
      <img src="../assets/pc/pia-logo.png" alt="">
      Copyright © PIA Corporation. All Rights Reserved.
    </div>
  </div>
</template>

<script>
import { Preloader } from "../loader/Preloader";
import API from "../api/API";

export default {
  name: "PC",
  computed: {
    bg() {
      return this.$store.getters["concert/largeBg"];
    }
  },
  data() {
    return {
      containerHeight: 720,
      marginLeft: 0,
      marginRight: 0,
      margin: 0
    };
  },
  async mounted() {
    await this.getConcertInfo();
    this.resize();
    window.addEventListener("resize", this.resize);
  },
  methods: {
    async getConcertInfo() {
      const concertId = this.$store.state.concert.concertId;
      return await API.getConcertInfo(concertId);
    },
    resize() {
      const innerWidth = window.innerWidth;
      // if (innerWidth < 1600) {
      //   this.margin = (innerWidth - 1600) * 0.5;
      // } else {
      //   this.margin = 0;
      // }
      if (1600 < innerWidth) {
        this.marginLeft = 0;
      }
      else if (1300 < innerWidth && innerWidth < 1600) {
        this.marginLeft = innerWidth - 1600;
      }
      else {
        this.marginLeft = -300;
      }
      this.marginRight = this.marginLeft;
      if (window.innerHeight > 720) this.containerHeight = window.innerHeight;
    }
  }
};
</script>

<style lang="sass">
html, body
  min-height: 100%
  background-color: #000
</style>
<style scoped lang="sass">
@import "../sass/common"
@import "../sass/zindex"
.pcContainer
  width: 100%
.pc
    //min-height: 100%
    height: 100%
    text-align: center
    max-width: 1600px
    margin: auto
    overflow: hidden
    .pc__inner
        width: 100%
        //height: 720px
        height: 100%
        position: relative
        overflow: hidden
    .pc__grad
        position: absolute
        width: 100%
        bottom: 28px
    .bg-grad
        position: absolute
        width: 100%
        height: 239px
        background: url("../assets/pc/bg-grad.png") repeat-x 0 0
        bottom: 0
    .bg
        position: absolute
        width: 100%
        //height: 645px
        height: 100%
        background-size: cover
        background-position: center center
        background-repeat: no-repeat
    .bgLeft
      background: url("../assets/pc/bg-left.png") 0 0 repeat-y
      position: absolute
      width: 300px
      height: 100%
    .bgRight
      background: url("../assets/pc/bg-right.png") 0 0 repeat-y
      position: absolute
      width: 300px
      height: 100%
      right: 0

    .texts
      position: absolute
      bottom: 15px
      width: 100%
      .texts__inner
        position: relative
        margin: auto
        width: 858px
      //left: 211px
    .text
      display: block

    .qr
      display: block
      position: absolute
      bottom: 2px
      right: 0
      width: 86px
.pc__footer
  img
    vertical-align: top
  text-align: center
  position: fixed
  bottom: 0
  z-index: 10
  width: 100%
  font-size: 10px
  height: 29px
  border-top: 1px solid #4d5153
  background-color: #0c1114
  line-height: 28px
</style>
